import React from 'react'
import Picture from '../../components/Picture'
import { Fragment } from 'react'


export default function () {
    return (
        <Fragment>
            <div className="container section-text-centered">
                <h2 className="title">Venda online com o <nobr>E-commerce B2B</nobr></h2>
                <h3 className="description">Portal de relacionamento com seu cliente PJ para vendas 24h por dia</h3>
            </div>
            <div className="container home-two-col sell-online-b2b">
                <div className="column">
                    <div className="checklist">
                        <div className="checklist-item">
                            <div className="checkmark checkmark-green"> </div>
                            <p><b>Criação em poucos cliques</b>: integrado ao sistema de vendas, sem retrabalho no cadastro de produtos ou tabelas de preços.</p>
                        </div>
                        <div className="checklist-item">
                            <div className="checkmark checkmark-green">&nbsp;</div>
                            <p><b>Venda personalizada</b>: acesso com login e senha pelo cliente para exibição de condições e preços de acordo com a sua tabela.</p>
                        </div>
                        <div className="checklist-item">
                            <div className="checkmark  checkmark-green"> </div>
                            <p><b>Suporte estratégico</b>: consultoria especializada para garantir o sucesso do e-commerce B2B no seu negócio.</p>
                        </div>
                        <div className="checklist-item">
                            <div className="checkmark checkmark-green"> </div>
                            <p><b>Aliado do representante e das vendas internas</b>: catálogo online para maior produtividade e resultados em vendas.</p>
                        </div>
                    </div>
                    <a className="new-button button-primary" href="/e-commerce-b2b/">saiba mais</a>
                </div>
                <div className="column img-col">
                    <Picture
                        className='purple-col-img-mobile'
                        src="/images/site/new-home/venda-online.png"
                        alt='Venda online com o E-commerce B2B'
                        mobileSrc="/images/site/new-home/venda-online-mobile.png"
                    />
                </div>


            </div>
        </Fragment>
    )
}




// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/SellOnlineB2B.jsx